import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconInvertColorComponent } from "./med-icon-invert-color.component";

@NgModule({
  declarations: [
    MedIconInvertColorComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconInvertColorComponent,
  ],
})
export class MedIconInvertColorModule { }
